export function getFirstYearInCalendar(itemsNumber) {
    return Math.floor(new Date().getFullYear() / itemsNumber) * itemsNumber + 1;
}
export function getPageIndexForSelectedYear(year, firstYearInCalendar, itemsNumber) {
    const lastYearInTable = firstYearInCalendar + (itemsNumber - 1);
    if (year > lastYearInTable) {
        return Math.ceil((year - lastYearInTable) / itemsNumber);
    }
    else if (year < firstYearInCalendar) {
        return Math.floor((year - firstYearInCalendar) / itemsNumber);
    }
    return 0;
}
export function formatYear(year) {
    let result = '';
    if (year === 0) {
        result = '0000';
    }
    else if (year && year > 0) {
        result = appendZeros(year.toString());
    }
    else if (year && year < 0) {
        result = '-' + appendZeros(year.toString().substr(1));
    }
    return result;
}
function appendZeros(year) {
    const digits = year.split('');
    if (digits.length < 4) {
        while (digits.length !== 4) {
            digits.unshift('0');
        }
    }
    return digits.join('');
}
